import { Customer, Dashlet, Location } from '@models/index';
import { Subject } from 'rxjs';

export class DashletAlarmOverview extends Dashlet {
    public ALARM_SUMMARY_BY_EQUIPMENT_COMMAND_TYPE_ID = '97BD0527-A111-40F1-AA04-EB6759EFCEE7';
    public ALARM_SUMMARY_BY_SEVERITY_COMMAND_TYPE_ID = '62568F87-2184-4F4B-B938-147BEEDE6529';

    public customer!: Customer;
    public location!: Location;
    public lastUpdated: string;

    public settingsChanged$: Subject<boolean> = new Subject<boolean>();
    public alarmDataTimedOut: boolean = true;
    public alarmSeverityDataTimedOut: boolean = true;

    public severitySettings: number[] = [];
    public severitySettingsChanged$: Subject<number[]> = new Subject<number[]>();

    constructor() {
        super();
        this.sizes = [
            {
                id: 1,
                label: 'Small',
                cols: 9,
                rows: 6
            },
            {
                id: 0,
                label: 'Large',
                cols: 9,
                rows: 13
            }
        ];

        this.applySize(0);
    }

    public applySettings(v: { [key: string]: any }): void {
        super.applySettings(v);
        this.configured = v.customer ? true : false;
        const previousCustomer: Customer = this.customer ? this.customer : null;
        if (this.configured) {
            this.customer = new Customer(v.customer.value, v.customer.label, v.customer.partnerId);
        } else {
            this.customer = new Customer('', '');
        }
        this.updateSize();
        if (this.configured) {
            this.customNameTag = v.nameTag;
            this.refreshNameTag();
            if (!previousCustomer || previousCustomer.customerId !== this.customer.customerId) {
                this.settingsChanged$.next(true);
            }

            const newSeveritySettings =
                (v.severitySettings && v.severitySettings.map((s: { value: number }) => s.value)) || [];

            if (JSON.stringify(this.severitySettings) !== JSON.stringify(newSeveritySettings)) {
                this.severitySettings = newSeveritySettings;
                this.severitySettingsChanged$.next(this.severitySettings);
            }
        }
    }

    public refreshNameTag(): void {
        if (this.lastUpdated === undefined) {
            return;
        }
        const originalDate = new Date(this.lastUpdated),
            originalDateNoMinutes = new Date(this.lastUpdated);
        originalDateNoMinutes.setMinutes(0, 0, 0);

        const _month = originalDate.toLocaleDateString(undefined, { month: 'short' });
        const _date = originalDate.toLocaleDateString(undefined, { day: 'numeric' });

        const firstDate: Date = new Date(originalDateNoMinutes);
        firstDate.setHours(firstDate.getHours() - 24);

        if (this.configured) {
            const _hour = originalDate
                .toLocaleTimeString(undefined, {
                    hour: 'numeric',
                    minute: 'numeric'
                })
                .toUpperCase();
            this.generatedNameTag = `${this.customer.customerName} | Last updated at ${_date}-${_month} ${_hour}`;
        } else {
            this.generatedNameTag = 'Unconfigured';
        }
    }

    public applySize(id: number): void {
        super.applySize(id);
        this.updateSize();
        this.refreshNameTag();
    }

    private updateSize(): void {
        const h = 0;
        const w = 0;
        this.applySizeExpansion(w, h);
    }

    public resetData(): void {}

    public dispose(): void {}
}
